import { Base } from "ui/Scripts/source/framework/base";
import { IRecordFamiliarizationListItem } from "ui/Scripts/source/models/recordFamiliarization/recordFamiliarizationListItem";
import { IRecordEditItemUserFamiliarization, RecordEditItemUserFamiliarization } from "ui/Scripts/source/models/recordUserFamiliarization/recordEditItemUserFamiliarization";

export interface IRecordEditItemFamiliarization extends IRecordEditItemUserFamiliarization {
    familiarizationCode: string;

    getTitle(): string;
    setFamiliarizationCode(familiarizations: IRecordFamiliarizationListItem[]);
}

export class RecordEditItemFamiliarization extends RecordEditItemUserFamiliarization implements IRecordEditItemFamiliarization {
    familiarizationCode: string;

    constructor();
    constructor(obj: IRecordEditItemFamiliarization);
    constructor(obj?: any) {
        super(obj);
        this.familiarizationCode = obj && obj.familiarizationCode || "";
    }

    getTitle(): string {
        return this.familiarizationCode + ", " + Base.utcTimeToDateStr(this.startDate);
    }

    setFamiliarizationCode(familiarizations: IRecordFamiliarizationListItem[]) {
        if (!this.familiarizationId) return;
        const familiarization = familiarizations.find(i => i.id === this.familiarizationId);
        if (!familiarization) return;
        this.familiarizationCode = familiarization.code;
    }

    static setFamiliarizationCodes(items: IRecordEditItemFamiliarization[], familiarizations: IRecordFamiliarizationListItem[]) {
        for (const item of items) {
            item.setFamiliarizationCode(familiarizations);
        }
    }

    static createNewRecordEditItemFamiliarization(familiarizations: IRecordFamiliarizationListItem[]) {
        const familiarization = familiarizations.length ? familiarizations[0] : null;
        const result = new RecordEditItemFamiliarization();
        result.id = Base.getGuid();
        result.familiarizationId = familiarization?.id ?? "";
        result.startDate = Base.getNowUtcDate().addDays(-1).getTime();
        result.activeState = 1;
        result.setFamiliarizationCode(familiarizations);
        return result;
    }
        
    static sortRecordEditItemFamiliarizations(items: IRecordEditItemFamiliarization[], column: string, asc: boolean): IRecordEditItemFamiliarization[] {
        if (!items && items.length < 2) return items;
        if (column === "startDate") {
            return items.sort((a: IRecordEditItemFamiliarization, b: IRecordEditItemFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.startDate, b.startDate)); });
        } else if (column === "endDate") {
            return items.sort((a: IRecordEditItemFamiliarization, b: IRecordEditItemFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.endDate, b.endDate)); });
        } else if (column === "validityEndDate") {
            return items.sort((a: IRecordEditItemFamiliarization, b: IRecordEditItemFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.validityEndDate, b.validityEndDate)); });
        } else if (column === "activeState") {
            return items.sort((a: IRecordEditItemFamiliarization, b: IRecordEditItemFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.activeState, b.activeState)); });
        } else if (column === "trainer") {
            return items.sort((a: IRecordEditItemFamiliarization, b: IRecordEditItemFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.trainer, b.trainer)); });
        } else if (column === "comment") {
            return items.sort((a: IRecordEditItemFamiliarization, b: IRecordEditItemFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        } else {
            return items.sort((a: IRecordEditItemFamiliarization, b: IRecordEditItemFamiliarization) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.familiarizationCode, b.familiarizationCode)); });
        }
    }
}